import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SiteDetailView from './siteDetailView';
import { getSiteDetail } from 'services/redux/sales/siteDashboard/action';

const mapStateToProps = (state) => ({
  siteDetail: state.siteDashboardReducer.siteDetail,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators({ getSiteDetail }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(SiteDetailView);
